import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  QuotationNewModelDto,
} from '@savgroup-front-common/types';
import { QuoteClientAnswer } from '@savgroup-front-common/types/Quotation/QuoteClientAnswer';

const ENDPOINT = `${APIConfiguration.repairer}quotes/answered`;

export interface SetQuoteClientAnswerCommandArgs {
  quoteId: string;
  clientAnswer: QuoteClientAnswer;
}

export const setQuoteClientAnswerRequest = (
  payload: SetQuoteClientAnswerCommandArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: { method: SUPPORTED_METHODS.POST, json: payload },
});

const setQuoteClientAnswerCommand = async (
  payload: SetQuoteClientAnswerCommandArgs,
): Promise<BackResponseFailure | BackResponse<QuotationNewModelDto[]>> => {
  try {
    return await executeQuery<BackResponse<QuotationNewModelDto[]>>(
      setQuoteClientAnswerRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default setQuoteClientAnswerCommand;
